import { BaseEntity } from '../core/entities/base.entity';
import { NoAuthorization } from './noAuthorization.model';
import { BasicAuth } from './basicAuth.model';
import { GlobalMetaDataEntity } from '../global-metadata/global-metadata.entity';
import { ConsumerData } from '../core/types';
import { SubjectEntity } from '../subject/subject.entity';

export interface LearnObjectTypeDescriptions {
  label: string
  metadata: GlobalMetaDataEntity[]
}

export class ConsumerEntity extends BaseEntity {
  name!: string;
  description!: string;
  authorization?: Authorization;
  availableClasses?: string[];
  baseColor?: string;
  competenceTree?: string;
  consumerData?: ConsumerData;
  consumerMetadata?: GlobalMetaDataEntity[];
  kiService?: boolean;
  learnObjectTypeDescriptions?: SavedLearnObjectType[];
  nlpSettings?: NlpSettings;
  playerFilesFolder?: string;
  playerSettings?: PlayerSettings;
  url?: string;
  urlPlaceholders?: string[];
  subjectConfigs?: string[];
  version?: string;
  changedBy?: string;
}

export type Authorization = NoAuthorization | BasicAuth;

export interface NlpSettings {
  nlpFeedbackLanguage?: string
  nlpFeedbackCorrectnessThreshold?: number
}

export interface PlayerTheme {
  primaryColor?: string
  secondaryColor?: string
  tertiaryColor?: string
  placeholderColor?: string
  hoverColor?: string
  drawColor?: string
  drawHighlightColor?: string
  compareSolutionsBgColor?: string
  useAudioIcon?: boolean
  useAudioIconTts?: boolean
  useAudioIconHelp?: boolean
  hideCopyrightInfoButton?: boolean
  forceSmallFooter?: boolean
  showSequenceGroupFinishedBtn?: boolean
  lightDialogs?: boolean
  hideShareCheckbox?: boolean
  hideSequenceTitle?: boolean
  isKapReview?: boolean
}

export interface PlayerSettings {
  selfJudgementPopup?: boolean
  dontKnowBtn?: boolean
  readoutExerciseText?: boolean
  randomOrderOfTestSequences?: boolean
  textSelectionEnabled?: boolean
  emptyAnswerWarningPopup?: boolean
  checkAnswerPopup?: boolean
  showNoteButton?: boolean
  showBottomPart?: boolean
  showSelfRating?: boolean
  showExerciseSequenceTabs?: boolean
  hideExerciseHeadline?: boolean
  maxTries?: number
  retryMode?: string
  hideResetExerciseButton?: boolean
  showCompletionIcons?: boolean
  tabLetters?: string
  disableExerciseFeedback?: boolean
  flattenExercises?: boolean
  footerInfo?: string
  theme?: PlayerTheme
  subjectConfigs?: SubjectConfig[]
  allowedFrontendOrigins?: unknown[]
}

export interface SubjectConfig {
  subjectId: string
  fontId?: string
}

export interface Competency {
  treeId?: string
  root?: boolean
}

export interface GroupedCompetencies {
  letter: string
  competencies: SubjectEntity[]
}

export interface SavedLearnObjectType {
  label: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: any[]
}
